import React from "react";
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import coins from "../../../assets/icon/coins.png";
import user from "../../../assets/icon/user.png";
import wallet from "../../../assets/icon/wallet.png";
import items from "../../../assets/icon/item.png";
import { useEffect, useState , useContext } from "react";
import { ExpertWallet } from "../../../services/kojaServices";
import { getCash } from "../../../services/kojaServices";
import { toast } from "react-hot-toast";
import { expertContext } from "../../../context/expertcontext";
import Num2persian from "num2persian";
const Wallet = () => {
  const [info, setInfo] = useState({});
  const [list, setList] = useState([]);
  const [decrease, setDecrease] = useState(0);
  const[price,setPrice]= useState(0)
  const {  setPage} = useContext(expertContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setPage("کیف پول")
        const { data } = await ExpertWallet();
        setInfo(data.result);
        setList(data.result.Ex_Expertsـtransactions);
        let sum = 0;
        data.result.Ex_Expertsـtransactions.map((i) => {
          if (i.decrease) {
            sum += i.decrease;
          }
          setDecrease(sum);
        });
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  const sendCash = async()=>{
    try{
      let cost = document.getElementById('cost').value
      if(cost){
        const {data} = await getCash(cost)
        toast.success(`${data.result_message}`)
      }
     
    }catch(err){
      console.log(err)
      toast.error('خطایی رخ داده است. مجدد تلاش کنید')
    }
  }
  return (
    <div className="wallet-page mb-0" style={{ paddingTop: "10px" }}>
      <Header />
      <div className="d-flex my-request-box">
        <Menu />
        <div>
          <div className="row g-0 w-100 mt-3 justify-content-around">
            <div className="col-xl-4 col-lg-5 col-md-5 col-12  row">
              <div className="col-sm-6 pb-0 col-md-12  mb-1">
                <div
                  className=" wallet-item"
                  style={{ backgroundColor: "rgba(255, 166, 0, 0.5)" }}
                >
                  <div className="">
                    <img alt="" src={coins} />
                    <p className="mb-0">موجودی</p>
                  </div>
                 <div>
                  <strong>{info.wallet?.toLocaleString()}</strong>
                  <small>تومان</small>
                 </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-12  mb-1">
                <div
                  className="wallet-item"
                  style={{ backgroundColor: "rgba(223, 198, 151, 0.5)" }}
                >
                  <div className="text-end">
                    <img alt="" src={wallet} />
                    <p>برداشت</p>
                  </div>
                  <div>
                  <strong>{decrease.toLocaleString()}</strong>
                  <small>تومان</small>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-12  mb-1">
                <div
                  className="wallet-item"
                  style={{ backgroundColor: "rgba(162, 175, 164, 0.5)" }}
                >
                  <div className="text-end">
                    <img alt="" src={items} />
                    <p>تعداد تراکنش</p>
                  </div>
                  <strong>{list.length}</strong>
                </div>
              </div>
              <div className="col-sm-6 col-md-12  mb-1">
                <div
                  className="wallet-item"
                  style={{ backgroundColor: "rgba(115, 159, 177, 0.5)" }}
                >
                  <div className="text-end">
                    <img alt="" src={user} height="50px" />
                    <p>تعداد کارشناسی</p>
                  </div>
                  <strong>{info.bachlorCount}</strong>
                </div>
              </div>
            </div>

            <div className="col-xl-5 col-lg-5 col-md-5 col-12 row">
              <div className="col-12 col-md-12  mb-1">
                <div className="col-12 col-md-12  mb-1">
                  <div className="wallet-list-box">
                    <p
                      className="wallet-list-item"
                      style={{ backgroundColor: "#b2d9bd" }}
                    >
                      لیست واریزی ها
                    </p>
                    <div className="wallet-item-box">
                      {list.map(
                        (i, index) =>
                          i.increase && (
                            <div
                              key={index}
                              className="wallet-list-item mb-2"
                              style={{ backgroundColor: "#b2d9bd" }}
                            >
                              <div className="d-flex  justify-content-between">
                                <p className="mb-0">
                                  {i.increase.toLocaleString()}
                                </p>
                                <p className="mb-0">{i.fa_date}</p>
                              </div>
                              <p className="mb-0 text-end">
                              بابت صورت کارشناسی : {i.requestToken}-{i.reason == "Bachlor-PrePayment"? "پیش پرداخت" : "صدور صورت"}
                              </p>
                            </div>
                          )
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-12  mb-1">
                <div className="wallet-list-box">
                  <p
                    className="wallet-list-item"
                    style={{ backgroundColor: "#FFDA94" }}
                  >
                    لیست برداشت ها
                  </p>
                  <div className="wallet-item-box">
                    {list.map(
                      (i, index) =>
                        i.decrease && (
                          <div
                            className="mb-2 wallet-list-item"
                            key={index}
                            style={{ backgroundColor: "#FFDA94" }}
                          >
                            <div className="d-flex  justify-content-between">
                              <p className="mb-0">
                                {i.decrease.toLocaleString()}
                              </p>
                              <p className="mb-0">{i.fa_date}</p>
                            </div>
                            <p className="mb-0 text-end">
                              {/* شماره پیگیری تراکنش: {i.trackingCode} */}
                              {i.reason == "Site-Commission" ? "کمیسیون سایت صورت کارشناسی: ":"شماره پیگیری تراکنش"} − {i.reason == "Site-Commission"? i.requestToken:i.trackingCode}
                              {/* بابت صورت کارشناسی : {i.requestToken}-{i.reason == "Bachlor-PrePayment"? "پیش پرداخت" : "صدور صورت"} */}
                            </p>
                          </div>
                        )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="wallet-new-request mt-2">
            <strong style={{ marginBottom: "10px", fontSize: "20px" }}>
              برداشت از کیف پول
            </strong>
            <div>
              <input type="number" id="cost" placeholder="مبلغ مورد نظر برای برداشت را وارد کنید" onChange={(e)=>{setPrice(e.target.value)}} />
              <button className="text-nowrap" onClick={()=>{sendCash()}}>درخواست جدید</button>
            </div>
            {
              price>0 && <p>{Num2persian(price)} تومان</p>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Wallet;
